<!--
 * @Author: Tina Huang
 * @Date: 2022-09-26 13:04:31
 * @LastEditors: Tina Huang
 * @LastEditTime: 2022-12-24 19:13:02
 * @Description: 
-->
<template>
  <div class="item" :class="mode">
    <slot></slot>
    <div class="dot" id="dot-1"></div>
    <div class="dot" id="dot-2"></div>
    <div class="dot" id="dot-3"></div>
    <div class="dot" id="dot-4"></div>
  </div>
</template>
<script>
export default {
  props: ["mode"],
}
</script>
<style lang="less" scoped>
@import url(../../less/var.less);
.item {
  margin: 0.3rem auto;
  max-width: 50vw;
  border-radius: 10px;
  border: 2px solid @primary-color;
  background: @third-color;
  box-sizing: border-box;
  padding: 0.5rem;
  position: relative;

  &.compact {
    padding: .2rem .5rem;
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    border: 2px solid @primary-color;
    background: @second-color;
    position: absolute;
    &#dot-1 {
      top: 10px;
      left: 10px;
    }
    &#dot-2 {
      top: 10px;
      right: 10px;
    }
    &#dot-3 {
      bottom: 10px;
      left: 10px;
    }
    &#dot-4 {
      bottom: 10px;
      right: 10px;
    }
  }
}
</style>
